import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';

import { ChLoading, chLoadingParams } from './ch-loading.class';
import { LoadFactors } from './load-coefficients.class';
import loadingParams from '../DesignLoading/misc/loadingParams';
import './styles.scss';
import { setPanelOptions } from '@reducers/options/panel/actions';
import { updateCalculateDesignLoadData } from '@reducers/selectors/loads/actions';

import TableInput from "../../components/TableInput";

import { BRAND, defaultUnits } from "@config";
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS, getTooltip } from '../../../../../src/texts/tooltips';
import { unitTransform, mergeDeep } from '@services/helper.service';
import { brandList } from '../../../../../src/app.values';

class CharacteristicsLoading extends Component {

  static propTypes = {
    animatePanel: PropTypes.func.isRequired
  };

  state = {
    loadFactors: new LoadFactors()
  };

  render() {
    return (
      <div className="calculation">
        <section className="list-type CharacteristicsLoading">
          <Table bordered className="CharacteristicsLoading__table">
            <thead className="thead">
            <tr>
              <th/>
              <th>{APP_TEXTS.DEAD_LOAD_D.Content}</th>
              <th>{APP_TEXTS.LIVE_LOAD_L.Content}</th>
              <th>{APP_TEXTS.TEMPORARY_LOAD_A.Content}</th>
              <th>{APP_TEXTS.ULTIMATE_LOADS.Content}</th>
            </tr>
            </thead>
            <tbody className="tbody">
            <tr>
              <th scope="row">{APP_TEXTS.PARTIAL_SAFETY_FACTOR.Content}</th>
              <td> 
                <Tooltip content={BRAND === brandList.Sea ? 
                  APP_TOOLTIPS.TOOLTIP_SAFETY_FACTOR_DEAD_LOAD.Content.replace('1,35', '2') : 
                  APP_TOOLTIPS.TOOLTIP_SAFETY_FACTOR_DEAD_LOAD.Content}>
                  <input
                    className="form-control CharacteristicsLoading__input"
                    type="number"
                    lang="fr"
                    name={chLoadingParams.DEAD_LOAD}
                    min="1"
                    step="0.05"
                    value={this.props.loadData[chLoadingParams.DEAD_LOAD].partialSafetyFactor}
                    onChange={e => this.updatePartialFactor(chLoadingParams.DEAD_LOAD, e.target.value)}
                  />
                </Tooltip>
              </td> 
              <td>
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_SAFETY_FACTOE_LIVE_LOAD.Content}>
                <input
                  className="form-control CharacteristicsLoading__input"
                  type="number"
                  lang="fr"
                  name={chLoadingParams.LIVE_LOAD}
                  min="1"
                  step="0.05"
                  value={this.props.loadData[chLoadingParams.LIVE_LOAD].partialSafetyFactor}
                  onChange={e => this.updatePartialFactor(chLoadingParams.LIVE_LOAD, e.target.value)}
                />
                </Tooltip>
              </td>
              <td>
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_SAFETY_FACTOR_TEMPORARY_LOAD.Content}>
                <input
                  className="form-control CharacteristicsLoading__input"
                  type="number"
                  lang="fr"
                  name={chLoadingParams.TEMPORARY_LOAD}
                  min="1"
                  step="0.05"
                  value={this.props.loadData[chLoadingParams.TEMPORARY_LOAD].partialSafetyFactor}
                  onChange={e => this.updatePartialFactor(chLoadingParams.TEMPORARY_LOAD, e.target.value)}
                />
                </Tooltip>
              </td>
              <td/>
            </tr>
            </tbody>

            <tbody>
            {this.props.loadRows.map((obj, i) => (
              <tr key={obj.title} className="LoadTableRow">
                <th scope="row">{obj[chLoadingParams.TITLE]}</th>
                <td className="CharacteristicsLoading__td">
                  <Tooltip content={obj.tooltip}>
                    <TableInput
                      className="cell-input"
                      name={chLoadingParams.DEAD_LOAD}
                      value={+obj[chLoadingParams.DEAD_LOAD]}
                      defaultUnit={i < 3 ? defaultUnits.LOAD : defaultUnits.MOMENT}
                      currentUnit={i < 3 ? this.props.loadUnit : this.props.momentUnit}
                      onBlur={() => this.props.animatePanel(false, obj)}
                      onFocus={() => this.props.animatePanel(true, obj)}
                      onInput={(value, invalidNumber) =>  {
                        if (!invalidNumber) {
                          this.props.setPanelValue(
                            obj, 
                            value, 
                            chLoadingParams.DEAD_LOAD, 
                            +this.calculate(mergeDeep({}, obj, { [chLoadingParams.DEAD_LOAD]: value })));
                        }}
                      }
                    />
                  </Tooltip>
                </td>
                <td className="CharacteristicsLoading__td">
                  <Tooltip content={obj.tooltip}>
                      <TableInput
                        className="cell-input"
                        name={chLoadingParams.LIVE_LOAD}
                        value={+obj[chLoadingParams.LIVE_LOAD]}
                        defaultUnit={i < 3 ? defaultUnits.LOAD : defaultUnits.MOMENT}
                        currentUnit={i < 3 ? this.props.loadUnit : this.props.momentUnit}
                        onBlur={() => this.props.animatePanel(false, obj)}
                        onFocus={() => this.props.animatePanel(true, obj)}
                        onInput={(value, invalidNumber) =>  {
                          if (!invalidNumber) {
                            this.props.setPanelValue(
                              obj,
                              value,
                              chLoadingParams.LIVE_LOAD,
                              +this.calculate(mergeDeep({}, obj, { [chLoadingParams.LIVE_LOAD]: value })));
                          }}
                        }
                      />
                  </Tooltip>
                  </td>
                <td className="CharacteristicsLoading__td">
                  <Tooltip content={obj.tooltip}>
                    <TableInput
                      className="cell-input"
                      name={chLoadingParams.TEMPORARY_LOAD}
                      value={+obj[chLoadingParams.TEMPORARY_LOAD]}
                      defaultUnit={i < 3 ? defaultUnits.LOAD : defaultUnits.MOMENT}
                      currentUnit={i < 3 ? this.props.loadUnit : this.props.momentUnit}
                      onBlur={() => this.props.animatePanel(false, obj)}
                      onFocus={() => this.props.animatePanel(true, obj)}
                      onInput={(value, invalidNumber) =>  {
                        if (!invalidNumber) {
                          this.props.setPanelValue(
                            obj, 
                            value, 
                            chLoadingParams.TEMPORARY_LOAD, 
                            +this.calculate(mergeDeep({}, obj, { [chLoadingParams.TEMPORARY_LOAD]: value })));
                        }}
                      }
                    />
                  </Tooltip>
                </td>
                <td>{unitTransform(+this.calculate(obj))
                  .from(i < 3 ? defaultUnits.LOAD : defaultUnits.MOMENT)
                  .to(i < 3 ? this.props.loadUnit : this.props.momentUnit)}
                </td>
              </tr>
            ))}
            </tbody>
          </Table>
        </section>
      </div>
    );
  }

  calculate(rowValue, data) {
    let loadData = data;
    if (!loadData)
      loadData = this.props.loadData;
      
    let sum = 0;
    Object.keys(loadData).forEach((key) => {
        sum += +loadData[key].partialSafetyFactor * rowValue[key];
      });

    return sum;
  //return Math.round(sum * 100) / 100;
  }

  updatePartialFactor(key, newFactor) {
    var newLoadData = mergeDeep({}, this.props.loadData);
    newLoadData[key].partialSafetyFactor = newFactor;
    var animateObj = { };
    this.props.loadRows.forEach((obj) => {
      let newSum = this.calculate(obj, newLoadData);
      mergeDeep(animateObj, {
        [obj.action]: {
          [obj.animationName]: {
            fixed: !!newSum,
            value: newSum || null,
          }
        }
      });
    });
    
    this.props.setPanelOptions({ animate: animateObj }); // update Scene loads
    this.props.updatePartialFactor(key, newFactor);
  }

}

const mapState = state => ({
  loadUnit: state.main.units.load,
  momentUnit: state.main.units.moment,
  loadData: state.selectors.loads[state.main.appType].calculateDesignLoadData,

  loadRows: Array(loadingParams.length).fill(null).map((item, idx) => {
    const loading = new ChLoading({
      title: loadingParams[idx].title,
      tooltip: getTooltip(loadingParams[idx].tooltip.Id)
    });

    const data = state.selectors.loads[state.main.appType].calculateDesignLoadData;

    loading.deadLoad = data[chLoadingParams.DEAD_LOAD][loading.title] || 0;
    loading.liveLoad = data[chLoadingParams.LIVE_LOAD][loading.title] || 0;
    loading.temporaryLoad = data[chLoadingParams.TEMPORARY_LOAD][loading.title] || 0;

    return loading;
  }),
  
});

const mapDispatch = dispatch => ({
  animatePanel: (isActive, obj) => {
    dispatch(setPanelOptions({
      animate: {
        [obj.action]: {
          [obj.animationName]: {
            active: isActive
          }
        }
      }
    }));
  },

  setPanelValue: (obj, value, col, ultVal) => {
    dispatch(setPanelOptions({
      animate: {
        [obj.action]: {
          [obj.animationName]: {
            fixed: !!ultVal,
            value: ultVal || null,
          }
        }
      }
    }));

    dispatch(updateCalculateDesignLoadData({
      [col]: {
        [obj.title]: +value
      }
    }));
  },

  updatePartialFactor: (col, value) => {
    dispatch(updateCalculateDesignLoadData({
      [col]: {
        partialSafetyFactor: value
      }
    }));
  },

  setPanelOptions: (options) => { dispatch(setPanelOptions(options)); }
});

export default connect(mapState, mapDispatch)(CharacteristicsLoading);



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/CharacteristicsLoading/index.js